export const RAIL_LIMIT = 6;
export interface RailEffect {
  scale: number;
  blur: number;
  ms: number;
}
export interface RailMotion {
  hover: RailEffect;
  others: RailEffect;
  preview: RailEffect;
}
export const DEFAULT_RAIL_MOTION: RailMotion = {
  hover: { scale: 1.15, blur: 0, ms: 280 },
  others: { scale: 0.88, blur: 1.5, ms: 280 },
  preview: { scale: 0.94, blur: 8, ms: 280 },
};
export const RAIL_EFFECT_RANGES = {
  scale: { min: 0.2, max: 1.6, step: 0.01, suffix: '' },
  blur: { min: 0, max: 24, step: 0.5, suffix: 'px' },
  ms: { min: 0, max: 2000, step: 10, suffix: 'ms' },
} as const;

export function clampRailMotion(value: unknown): RailMotion {
  const raw =
    value && typeof value === 'object'
      ? (value as Record<string, unknown>)
      : {};
  const effect = (key: keyof RailMotion): RailEffect => {
    const source = raw[key];
    const fields =
      source && typeof source === 'object'
        ? (source as Record<string, unknown>)
        : {};
    const number = (field: keyof RailEffect) => {
      const n = fields[field];
      const range = RAIL_EFFECT_RANGES[field];
      return typeof n === 'number' && Number.isFinite(n)
        ? Math.min(range.max, Math.max(range.min, n))
        : DEFAULT_RAIL_MOTION[key][field];
    };
    return { scale: number('scale'), blur: number('blur'), ms: number('ms') };
  };
  return {
    hover: effect('hover'),
    others: effect('others'),
    preview: effect('preview'),
  };
}
